var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"button",attrs:{"to":{name: _vm.dest},"tag":"button"}},[_vm._v(_vm._s(_vm.dest))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }